import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PdfExportState {
  includeContactInformation: boolean;
  includeAdditionalInformation: boolean;
  includeClientDescription: boolean;
  includeFollowUpHistory: boolean;
}

const initialState: PdfExportState = {
  includeContactInformation: true,
  includeAdditionalInformation: true,
  includeClientDescription: true,
  includeFollowUpHistory: true,
};

export const pdfExportSlice = createSlice({
  name: 'pdfExport',
  initialState,
  reducers: {
    updatePdfExportSettings: (state, action: PayloadAction<Partial<PdfExportState>>) => ({ ...state, ...action.payload }),
    toggleContactInformation: (state) => {
      state.includeContactInformation = !state.includeContactInformation;
    },
    toggleAdditionalInformation: (state) => {
      state.includeAdditionalInformation = !state.includeAdditionalInformation;
    },
    toggleClientDescription: (state) => {
      state.includeClientDescription = !state.includeClientDescription;
    },
    toggleFollowUpHistory: (state) => {
      state.includeFollowUpHistory = !state.includeFollowUpHistory;
    },
    resetPdfExportSettings: (state) => initialState,
  },
});

export const {
  updatePdfExportSettings,
  toggleContactInformation,
  toggleAdditionalInformation,
  toggleClientDescription,
  toggleFollowUpHistory,
  resetPdfExportSettings,
} = pdfExportSlice.actions;

export default pdfExportSlice;
